import { httpClient } from '@bcba/client-auth';
import { basePath } from '.';
import { GetExplorerUpdateAccessRequestsDto } from './dto';

export const updateAccessibleSectionsByUuid = async (
  uuid: string,
  dto: GetExplorerUpdateAccessRequestsDto,
) => {
  const { data } = await httpClient.patch(`${basePath}/${uuid}`, dto);

  return data;
};

export default updateAccessibleSectionsByUuid;
